module.exports = __webpack_public_path__ + "static/media/pm-filter-monitor.6d8a8b3a.svg";